import { useQuery } from "@tanstack/react-query";
import { swingCollectionsService } from "../../../services/swingCollections";

/**
 * Fetches outlier filter options (key positions, movement types, raw indicators).
 * No auth required.
 */
export function useOutliersFilters() {
  return useQuery({
    queryKey: ["getOutliersFilters_key"],
    queryFn: () => swingCollectionsService.getOutliersFilters(),
    staleTime: 10 * 60 * 1000,
  });
}
